import { IEsimProfileReservation, IEsimReservation } from "../../interfaces/esim/EsimReservations.types";
import { eur } from "../eur";
import {
  IRefundStatusView,
  refundReturnedNothing,
  refundStatusView
} from "../reservations/cancellationText";
import { refundGraceState } from "../reservations/refundGrace";

// Cancelled (3) and Refunded (4): the only statuses that carry a refund row.
const REFUNDED_STATUSES = [3, 4];

const CARD_STATE: Record<string, string> = {
  Pending: "te banka",
  Succeeded: "i kthyer",
  Failed: "dështoi",
  Canceled: "anuluar te banka"
};

// One badge for the eSIM's refund: where the money went, how much, and for a card refund where the bank
// says it is. The full bus-booking wording (dates included) goes in the tooltip.
export const esimRefundView = (
  reservation: IEsimReservation,
  now: number = Date.now()
): IRefundStatusView | null => {
  if (!REFUNDED_STATUSES.includes(reservation.status) || !reservation.refundScheduledForUtc) return null;
  const amount = reservation.amountRefunded ?? 0;
  const refund = {
    id: reservation.id,
    amount,
    isRefundInCredits: !!reservation.isRefundInCredits,
    refundScheduledForUtc: reservation.refundScheduledForUtc,
    processorStatus: reservation.refundProcessorStatus,
    processorConfirmedAtUtc: reservation.refundProcessorConfirmedAtUtc
  };
  if (refundReturnedNothing(refund)) return { label: "Pa rimbursim", tone: "muted" };
  if (refund.isRefundInCredits) return { label: `Rimbursuar në Gjirafa Money ${eur(amount)}`, tone: "ok" };

  const bank = refundStatusView(refund, now);
  const state = (refund.processorStatus && CARD_STATE[refund.processorStatus])
    ?? (refundGraceState(refund, now) === "open" ? "në pritje" : "në radhë");
  return {
    label: `Rimbursim në kartelë ${eur(amount)} · ${state}`,
    tone: bank.tone,
    note: [bank.label, bank.note].filter(Boolean).join(" · ")
  };
};

// The profile's reservations carry no bank state, so a card refund shows only its amount.
export const esimProfileRefundView = (
  reservation: IEsimProfileReservation
): IRefundStatusView | null => {
  const amount = reservation.amountRefunded ?? 0;
  if (amount <= 0) return null;
  return reservation.isRefundInCredits
    ? { label: `Rimbursuar në Gjirafa Money ${eur(amount)}`, tone: "ok" }
    : { label: `Rimbursim në kartelë ${eur(amount)}`, tone: "muted" };
};
